import React, { useMemo, useState } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import { formatAmount } from "../../../utils/constants";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
import TableSkelton from "../../../shared/TableSkelton";
import NoDataFound from "../../../shared/NoDataFound";
import API from "../../../services/api";
import * as XLSX from 'xlsx'

function SalesPerformanceTable({ data, salesList, MonthRange,isLoading,business }) {
  const [show, setShow] = useState(false)
  const [detailsData, setDetailsData] = useState([])
  const [loading, setLoading] = useState(false)
  // --- derive month keys from MonthRange ---
  const downloadXLSX = () => {
    if (!detailsData?.length) return;
  
    const sheetData = detailsData.map((row, idx) => ({
      "S.No": idx + 1,
      "Brand Name": row.brand_name,
      "Brand Location": row.brand_location,
      "Category": row.brand_category,
      "Sales":show,
      "Business":
        row.business === 0
          ? "Old"
          : row.business === 1
          ? "New"
          : "Re-engaged",
      "Revenue": formatAmount(row.amount),
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Brand Details");
  
    XLSX.writeFile(workbook, "brand_details.xlsx");
  };


const exportSalesTable = (monthKeys, salesList, salesDataMap, monthTotals, formatAmount) => {
  // --- Build 2 header rows ---
  const headerRow1 = ["Sales Name"];
  const headerRow2 = [""];

  monthKeys.forEach(m => {
    headerRow1.push(m.label, "", ""); 
    headerRow2.push("Clients", "Insertions", "Revenue");
  });

  const wsData = [headerRow1, headerRow2];

  // --- Data rows ---
  salesList.forEach(sales => {
    const row = [sales.label];
    monthKeys.forEach(m => {
      const record = salesDataMap[sales.value]?.[m.key];
      row.push(record?.clients ?? "-");
      row.push(record?.insertions ?? "-");
      row.push(formatAmount(record?.revenue) ?? "-");
    });
    wsData.push(row);
  });

  // --- Total row ---
  const totalRow = ["Total"];
  monthKeys.forEach(m => {
    totalRow.push(monthTotals[m.key].clients);
    totalRow.push(monthTotals[m.key].insertions);
    totalRow.push(formatAmount(monthTotals[m.key].revenue) ?? "-");
  });
  wsData.push(totalRow);

  // --- Create worksheet ---
  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // --- Merge header cells for each month label ---
  const merges = [];
  let col = 1;
  monthKeys.forEach(() => {
    merges.push({ s: { r: 0, c: col }, e: { r: 0, c: col + 2 } });
    col += 3;
  });
  // Merge "Sales Name" vertically (row 0–1)
  merges.unshift({ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } });
  ws["!merges"] = merges;

  // --- Optional: styling (Excel auto width) ---
  ws["!cols"] = [{ wch: 20 }, ...Array(monthKeys.length * 3).fill({ wch: 12 })];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sales Data");
  XLSX.writeFile(wb, "sales_table.xlsx");
};


  const fetchDetailsData = async(month, brand_ids, sales_person_id)=>{
    try {
      setLoading(true)
      let res = await API({
        url:"/phionex_reports/getNbdDetails",
        method:'POST',
        responseType:'json',
        data:{
          month,
          brand_ids,
          sales_person_id,
          business
        }
      })
      if(res.code === 200){
        setDetailsData(res.data)
      }
    } catch (error) {
      console.error(error)
    }
    finally{
      setLoading(false)
    }
  }
  const monthKeys = useMemo(() => {
    const months = [];
    const start = new Date(MonthRange[0]);
    const end = new Date(MonthRange[1]);
    const current = new Date(start);

    while (current <= end) {
      const key = `${current.getFullYear()}-${current.getMonth() + 1}`; // e.g. 2025-1
      const label = current.toLocaleString("en-US", {
        month: "short",
        year: "2-digit",
      }); // e.g. "Jan 25"
      months.push({ key, label });
      current.setMonth(current.getMonth() + 1);
    }
    return months;
  }, [MonthRange]);

  // --- map data by sales person & month ---
  const salesDataMap = useMemo(() => {
    const map = {};
    data.forEach((d) => {
      const month = new Date(d.month * 1000);
      const monthKey = `${month.getFullYear()}-${month.getMonth() + 1}`;
      if (!map[d.sales_person_id]) map[d.sales_person_id] = {};
      map[d.sales_person_id][monthKey] = {
        revenue: Number(d.revenue),
        clients: Number(d.clients),
        insertions: Number(d.insertions),
        sales_person_id:d.sales_person_id,
        brand_ids:d.brand_ids,
        month:d.month
      };
    });
    return map;
  }, [data]);

  console.log(salesDataMap)

  // --- compute totals per month ---
  const monthTotals = useMemo(() => {
    const totals = {};
    monthKeys.forEach((m) => {
      totals[m.key] = { revenue: 0, clients: 0, insertions: 0 };
    });
    data.forEach((d) => {
      const month = new Date(d.month * 1000);
      const key = `${month.getFullYear()}-${month.getMonth() + 1}`;
      if (totals[key]) {
        totals[key].revenue += Number(d.revenue);
        totals[key].clients += Number(d.clients);
        totals[key].insertions += Number(d.insertions);
      }
    });
    return totals;
  }, [data, monthKeys]);
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  return (
    <>
    <div className="flex flex-end justify-end">

    <button
      className=" bg-gray-200 px-2 py-1 mb-2 rounded-md hover:text-sky-500" title="Download Busines Development Data"
      onClick={() =>
        exportSalesTable(monthKeys, salesList, salesDataMap, monthTotals, formatAmount)
      }
    >
    &#8615;
    </button>
      
</div>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead className="bg-gray-100">
            <tr>
              <th className=" px-4 py-2 text-left" rowSpan={2}>
                Sales Name
              </th>
              {monthKeys.map((m) => (
                <th key={m.key} className=" px-4 py-2" colSpan={3}>
                  {m.label}
                </th>
              ))}
              
            </tr>
            <tr>
            {monthKeys.map((m) => (
                <>
                <th key={m.key} >
                  Clients
                </th>
                <th>Insertions</th>
                <th>Revenue</th>
                </>
              ))}
            </tr>
          </thead>
          {(!isLoading && data.length > 0) ? <tbody>
            {salesList.map((sales) => (
              <tr key={sales.value}>
                <td className=" px-4 py-2 text-left font-medium">
                  {sales.label}
                </td>
                {monthKeys.map((m) => {
                  const record = salesDataMap[sales.value]?.[m.key];
                  return (
                    <>
                    <td key={m.key} className=" px-4 py-2 text-blue-500" onClick={()=>{
                      setShow(sales.label)
                      fetchDetailsData(record.month, record.brand_ids, record.sales_person_id)
                    }}>
                      {record?.clients || '-'}
                    </td>
                    <td>
                      {record?.insertions || '-'}
                    </td>
                    <td>
                      {formatAmount(record?.revenue) || '-'}
                    </td>
                    </> );
                })}
              </tr>
            ))}
          </tbody> : isLoading ? <TableSkelton colspan={monthKeys.length *3 + 1} /> : <NoDataFound colspan={monthKeys.length *3 + 1} />}
          <tfoot className="bg-gray-100 font-semibold">
            <tr>
              <td className=" px-4 py-2 text-left" >
                Total
              </td>
              {monthKeys.map((m) => (
                <>
                <td key={m.key} className=" px-4 py-2">
                
                  {monthTotals[m.key].clients}
                </td>
                <td>
                  {monthTotals[m.key].insertions}
                </td>
                <td key={m.key} className=" px-4 py-2">
                  {formatAmount(monthTotals[m.key].revenue ) || '-'}
                </td>
                </>
              ))}
            </tr>
          </tfoot>
        </table>
      </ScrollContainer>
      <SlDrawer open={show} 
        onSlRequestClose={handleRequestClose} onSlAfterHide={()=>{setShow(false);setDetailsData([])}} label={`Business of ${show}`} style={{'--size':'50%'}}>
          <>
          <div className="flex flex-end justify-end">
            <button className=" bg-gray-200 px-2 py-1 mb-2 rounded-md hover:text-sky-500" title="Download Data" onClick={downloadXLSX}>&#8615;</button>
            </div>
          <table className="table table-bordered">
              <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Brand Name</th>
                    <th>Brand Location</th>
                    <th>Category</th>
                    <th>Business</th>
                    <th>Revenue</th>
                  </tr>
              </thead>
              {(!loading && detailsData.length > 0) ? <tbody>
                {detailsData.map((row,idx) => (
                  <tr key={row.brand_id}>
                    <td>{idx+1}</td>
                    <td>{row.brand_name}</td>
                    <td>{row.brand_location}</td>
                    <td>{row.brand_category}</td>
                    <td>{row.business === 0 ? 'Old' : row.business === 1 ? 'New' : 'Re-engaged'}</td>
                    <td>{formatAmount(row.amount)}</td>
                  </tr>
                ))}

              </tbody> : loading ? <TableSkelton colspan={5} /> : <NoDataFound colspan={5} />}
          </table>
          </>
      </SlDrawer>
      </>
  );
}

export default SalesPerformanceTable;
